var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.46 197.4"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.75 0L0 75.75v121.66h7V78.65L75.75 9.9l68.71 68.71v111.8H43.41l.33-59.63 22.86.25 29.06 29.06-6.16 6.16 23.05 6.18-6.18-23.05-5.76 5.76-31.08-31.08-32.75-.36-.41 73.71h115.09V75.71L75.75 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.35 156.57a12.88 12.88 0 1012.87-12.87 12.89 12.89 0 00-12.87 12.87zm18.75 0a5.88 5.88 0 11-5.88-5.87 5.89 5.89 0 015.88 5.87zM110.61 123.06a12.88 12.88 0 10-12.88 12.88 12.89 12.89 0 0012.88-12.88zm-18.76 0a5.88 5.88 0 115.88 5.88 5.88 5.88 0 01-5.88-5.88z"
  })))));
}

export default SvgLogo;